export const entryPaths = [
  {
    id: 'entry-home',
    icon: 'ri-home-4-line',
    badge: '主入口',
    title: '爆料专区首页入口',
    desc: '从首页进入可一览最新爆料、热门讨论与编辑精选内容，是全站内容的总枢纽。',
    tips: '建议先保存书签，避免每次重新搜索。',
  },
  {
    id: 'entry-latest',
    icon: 'ri-flashlight-line',
    badge: '实时',
    title: '最新爆料帖入口',
    desc: '按发布时间倒序聚合，第一时间捕捉刚刚出现的爆料线索与网友跟进讨论。',
    tips: '适合想追最新进展、蹲第一手消息的用户。',
  },
  {
    id: 'entry-hot',
    icon: 'ri-fire-line',
    badge: '高热度',
    title: '热门讨论区入口',
    desc: '以互动量、跟帖密度排序，集中展示正在发酵的热门话题与争议讨论。',
    tips: '热度榜每小时刷新一次，可反复回来查看。',
  },
  {
    id: 'entry-topic',
    icon: 'ri-layout-grid-line',
    badge: '分类',
    title: '主题专区入口',
    desc: '按娱乐、科技、财经、社会等主题分类，快速定位你长期关注的内容方向。',
    tips: '分类页支持关键词筛选，命中率更高。',
  },
  {
    id: 'entry-mobile',
    icon: 'ri-smartphone-line',
    badge: '移动端',
    title: '移动端访问入口',
    desc: '手机浏览器可直接打开站点，页面已做移动端适配，阅读与翻帖体验更顺畅。',
    tips: '弱网环境下建议关闭自动播放的内容。',
  },
  {
    id: 'entry-guide',
    icon: 'ri-compass-3-line',
    badge: '新手',
    title: '访问指南入口',
    desc: '不清楚从哪里开始？访问指南用分步说明带你熟悉站内结构与常用功能。',
    tips: '首次访问建议按顺序读完三个步骤。',
  },
];